class CartMilestone extends HTMLElement {
  constructor() {
    super();
    this.processing = false;
    this.animated = false;
    this.thresholds = JSON.parse(this.dataset.thresholds || '[]');
    this.progress = this.querySelector('.milestone-progress');
    this.pointsContainer = this.querySelector('.milestone-points');
    this.message = this.querySelector('.milestone-message');
    this.observer = new IntersectionObserver(this.handleIntersection.bind(this), { threshold: 0.3 });
    this.observer.observe(this);
    document.addEventListener('cart:updated', (event) => { this.update(event.detail); });
    this.getCart();
  }

  async getCart() {
    const response = await fetch('/cart.js');
    const cart = await response.json();
    this.update(cart);
  }

  handleLoading(status = true) {
    const drawer = document.querySelector('.drawer__inner');
    // drawer.classList.toggle('loading', status);
    let overlay = drawer.querySelector('.cart-loader');
    if (!drawer) return;
    if (status && !overlay) {
      overlay = document.createElement('div');
      overlay.className = 'cart-loader';
      overlay.innerHTML = `<div class="loader-spinner"> </div>`;
      drawer.appendChild(overlay);
    }
    if (!status && overlay) { overlay.remove(); }
  }

  handleIntersection(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting && !this.animated) {
        this.animated = true;
        this.animateProgress();
      }
    });
  }

  animateProgress() {
      this.progress.style.width = `${this.currentPercent || 0}%`;
  }

  async update(cart) {
    if (this.processing) return;
    this.processing = true;
    const max = this.thresholds[this.thresholds.length - 1]?.amount || 1;
    this.currentPercent = Math.min((cart.total_price / max) * 100, 100);
    this.animateProgress();
    this.updateActiveStates(cart.total_price);
    this.updateMessage(cart.total_price);
    await this.handleRewards(cart);
    this.processing = false;
  }

  updateMessage(total) {
    const next = this.thresholds.find(item => total < item.amount);
    if (!next) { this.message.innerHTML = `🎁 Best Free gift added! Checkout Now.`; return; }
    const remain = (next.amount - total) / 100;
    const message = next.message.replace("xx", `₹${remain.toFixed(0)}`);
    this.message.innerHTML = message;
  }

  updateActiveStates(total) {
    const points = this.querySelectorAll('.milestone-point');

    // Reset classes
    points.forEach((point, index) => {
      const threshold = this.thresholds[index];

      point.classList.remove('active', 'last');

      if (total >= threshold.amount) {
        point.classList.add('active');
      }
    });

    // Add 'last' to the last active milestone
    const lastActive = [...points].filter(point => point.classList.contains('active')).pop();

    if (lastActive) {
      lastActive.classList.add('last');
    }
  }

  async handleRewards(cart) {
    const updates = {};
    const itemsToAdd = [];

    const activeChoose = this.thresholds.filter(t => t.type === "choose" && cart.total_price >= t.amount)
      .sort((a, b) => b.amount - a.amount)[0];

    const activeUpgrade = this.thresholds.filter(t => t.type === "upgrade" && cart.total_price >= t.amount)
      .sort((a, b) => b.amount - a.amount)[0];

    // Choose Reward
    if (activeChoose) {
      this.showUpgradePopup(activeChoose);
      return;
    }

    // Upgrade Reward
    if (activeUpgrade) {
      const rewardItems = cart.items.filter(item => item.properties?._reward && !item.properties?._upgrade);

      if (!rewardItems.length) return;
      rewardItems.forEach(item => { updates[item.key] = 0; });

      if (Object.keys(updates).length) {
        await fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ updates })
        });
      }

      const rewardExists = cart.items.some(
        item =>
          item.variant_id == activeUpgrade.variantId &&
          item.properties?._reward
      );

      if (!rewardExists) {
        await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            items: [{
              id: activeUpgrade.variantId,
              quantity: 1,
              properties: {
                _reward: true,
                _upgrade: true,
                title: activeUpgrade.title || "Premium Gift"
              }
            }]
          })
        });
      }

      window.CartConfetti.fire();
      this.refreshCart();
      return;
    }
    
    // Auto Rewards
    const rewardMap = {};
    this.thresholds.forEach(threshold => {
      if (threshold.type !== "auto") return;

      rewardMap[threshold.variantId] ??= {
        variantId: threshold.variantId,
        qty: 0,
        title: threshold.title
      };

      if (cart.total_price >= threshold.amount) {
        rewardMap[threshold.variantId].qty++;
      }
    });

    Object.values(rewardMap).forEach(reward => {
      const rewardItem = cart.items.find(
        item =>
          item.variant_id == reward.variantId &&
          item.properties?._reward
      );

      if (reward.qty > 0) {
        if (rewardItem) {
          if (rewardItem.quantity !== reward.qty) {
            updates[rewardItem.key] = reward.qty;
          }
        } else {
          itemsToAdd.push({
            id: reward.variantId,
            quantity: reward.qty,
            properties: {
              _reward: true,
              title: reward.title
            }
          });
        }
      } else if (rewardItem) {
        updates[rewardItem.key] = 0;
      }
    });

    if (itemsToAdd.length) {
      await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: itemsToAdd })
      });
    }

    if (Object.keys(updates).length) {
      await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates })
      });
    }

    if (itemsToAdd.length || Object.keys(updates).length) {
      window.CartConfetti.fire();
      this.refreshCart();
    }
  }

  async selectUpgradeReward(variantId) {
    const cart = await fetch('/cart.js').then(res => res.json());
    const updates = {};
    // Remove all existing rewards
    cart.items.forEach(item => { 
      if (item.properties?._reward) { updates[item.key] = 0; }
    });
    // Remove old rewards first
    if (Object.keys(updates).length) {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });
    }
    // Add selected reward
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: 1,
          properties: {
            _reward: true,
            _choose: true
          }
        }]
      })
    });
    this.refreshCart();
  }

  async addReward(itemsToAdd) {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: itemsToAdd
      })
    });
    this.refreshCart();
  }

  async removeReward(updates) {
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        updates
      })
    });
    this.refreshCart();
  }

  async refreshCart(updateUI = true) { console.log('Cart Refresh');
    fetch('/?sections=cart-drawer,cart-icon-bubble')
      .then(res => res.json())
      .then(sections => {
        let cartHtml = sections['cart-drawer'];
        let tempDiv = document.createElement('div');
        tempDiv.innerHTML = cartHtml;
        const drawer = document.querySelector('cart-drawer');

        if (tempDiv.querySelector('cart-drawer')?.classList.contains('is-empty')) {
          document.querySelector('cart-drawer .drawer__inner').innerHTML = tempDiv.querySelector('cart-drawer .drawer__inner').innerHTML || '';
        } else {
          let drawerInner = tempDiv.querySelector('cart-drawer-items');
          document.querySelector('cart-drawer cart-drawer-items').innerHTML = drawerInner.innerHTML;
          let cartDrawerFooter = tempDiv.querySelector('.cart-drawer-footer');
          document.querySelector('.cart-drawer-footer').innerHTML = cartDrawerFooter?.innerHTML;
        }
        this.handleLoading(false);

        if (drawer?.classList.contains('is-empty')) { drawer.classList.remove('is-empty'); }

        // console.log(drawerInner.innerHTML);
        const bubble = document.querySelector('#cart-icon-bubble');
        if (bubble) { bubble.innerHTML = sections['cart-icon-bubble']; }
        const cartIcon = document.querySelector('#cart-icon-bubble a, #cart-icon-bubble');
      })
      .catch(e => {
        console.error(e);
        this.handleLoading(false); console.log('log error');
      });
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  async validateRemoveItem(lineIndex, newQty = 0) {
    const response = await fetch("/cart.js");
    const cart = await response.json();

    const item = cart.items[lineIndex - 1];

    if (!item) {
      return {
        confirmed: true,
        updates: {}
      };
    }

    const qtyDiff = item.quantity - newQty;

    // Quantity increased or unchanged
    if (qtyDiff <= 0) {
      return {
        confirmed: true,
        updates: {
          [item.key]: newQty
        }
      };
    }

    const removeAmount =
      (item.final_line_price / item.quantity) * qtyDiff;

    const currentTotal = cart.total_price;
    const newTotal = currentTotal - removeAmount;

    const updates = {
      [item.key]: newQty
    };

    // Remove rewards that will no longer qualify
    this.thresholds.forEach((threshold) => {

      const willLoseReward =
        currentTotal >= threshold.amount &&
        newTotal < threshold.amount;

      if (!willLoseReward) return;

      let rewardItem;

      switch (threshold.type) {

        case "auto":
          rewardItem = cart.items.find(item =>
            item.variant_id == threshold.variantId &&
            item.properties?._reward &&
            !item.properties?._upgrade &&
            !item.properties?._choose
          );
          break;

        case "upgrade":
          rewardItem = cart.items.find(item =>
            item.properties?._upgrade
          );
          break;

        case "choose":
          rewardItem = cart.items.find(item =>
            item.properties?._choose
          );
          break;

        default:
          return;
      }

      if (rewardItem) {
        updates[rewardItem.key] = 0;
      }

    });

    return {
      confirmed: true,
      updates
    };
  }

  async processRemove(lineIndex, newQty = 0, updateUI = false) {
    this.handleLoading(true);

    try {
      const result = await this.validateRemoveItem(lineIndex, newQty);

      if (!Object.keys(result.updates).length) {
        this.handleLoading(false);
        return null;
      }

      // Update cart
      await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          updates: result.updates
        })
      });

      // Get latest cart
      const cart = await fetch("/cart.js").then(res => res.json());

      // Update progress UI
      const max = this.thresholds[this.thresholds.length - 1]?.amount || 1;
      this.currentPercent = Math.min(
        (cart.total_price / max) * 100,
        100
      );

      this.animateProgress();
      this.updateActiveStates(cart.total_price);
      this.updateMessage(cart.total_price);

      // Recalculate rewards
      await this.handleRewards(cart);

      // Refresh drawer
      this.refreshCart(updateUI);

      return true;

    } catch (error) {
      console.error("processRemove Error:", error);
      return false;
    } finally {
      this.handleLoading(false);
    }
  }
}

customElements.define('cart-milestone', CartMilestone);